<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <v-btn :disabled="filteredSourceTypes.length === 0" v-on="on" small color="info">
        <v-icon class="mr-2">add</v-icon>
        Add data source..
      </v-btn>
    </template>

    <v-card dark>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Add Data Source</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card>
      <v-form ref="form">
        <v-alert class="my-0" outline type="warning" :value="sourceType && sourceDataTypes.length === 0" transition="fade">
          <div class="primary--text">
            All data sources of this type are already assigned.
          </div>
        </v-alert>
        <v-card-text>
          <p>
            Data sources must be unassigned to add. To move them, use the Data Sources tab on this page.
          </p>
          <v-select label="Data Type" clearable v-model="sourceType" :rules="[rules.required]" :items="filteredSourceTypes" item-value="key" item-text="dataType" hint="Only showing data types available for this location, since a location can only have one of each data types." persistent-hint />
          <v-autocomplete label="Data Source" no-data-text="No data types available" clearable v-model="newDataType" :rules="[rules.required]" item-text="LocationIdentifier" return-object :items="sourceDataTypes" :disabled="!sourceType || sourceDataTypes.length === 0" hint="Only showing data sources that do are not already assigned to a location" persistent-hint />
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn color="info" @click="submit()">
          <v-icon class="mr-2">add</v-icon>
          Add
        </v-btn>
        <v-btn depressed @click="close()">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const dataSources = createNamespacedHelpers('datasource')
  import {
    SOURCE_TYPES_WITH_NAME,
    SOURCE_TYPES_WITH_NAME_INDEX,
  } from '@/store/MonitoringFeature/monitoringfeature'


  export default {
    props: {
      value: Array,
      mfId: Number,
    },
    data: () => ({
      SOURCE_TYPES_WITH_NAME,
      dialog: false,
      newDataType: null,
      sourceType: null,
      rules: {
        required: (v) => !!v || 'Required',
        uniqueDataType: (v) => {
          let isUnique = this.value.filter(ds => ds.sourceType == v).length === 0
          return isUnique || 'Data type already assigned'
        },
      },
    }),
    computed: {
      ...dataSources.mapGetters(['dataSources']),
      sourceDataTypes() {
        if (!this.sourceType) return []
        let dataSources = this.dataSources[this.sourceType]

        if (!dataSources) return []
        return dataSources.filter(ds => !ds.MonitoringFeatureId || ds.MonitoringFeatureId == this.mfId)
      },
      filteredSourceTypes() {
        return this.SOURCE_TYPES_WITH_NAME.filter(st => this.value.every(dataType => dataType.sourceType != st.key))
      },
    },
    watch: {
      filteredSourceTypes: {
        immediate: true,
        handler(val) {
          if (!val || val.length === 0) {
            this.sourceType = null
          } else this.sourceType = val[0].key
        },
      },
      sourceDataTypes(val) {
        if (!val || val.length === 0) {
          this.newDataType = null
        } else this.newDataType = val[0]
      },
    },
    methods: {
      close() {
        this.dialog = false
      },
      show() {
        this.dialog = true
      },
      async submit() {
        if (!this.$refs.form.validate()) return

        let dataSources = [...this.value]
        dataSources.push({
          name: this.newDataType.LocationIdentifier,
          dataTypeName: SOURCE_TYPES_WITH_NAME_INDEX[this.sourceType].dataType,
          sourceType: this.sourceType,
          station: this.newDataType,
        })
        this.$emit('input', dataSources)
        this.close()
      },
    },
  }
</script>